import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from "react-router-dom";
import { Box, DataGrid, SelectBox } from "devextreme-react";
import { Column, Editing, Popup, Form, Button, Pager, Paging, FilterRow } from "devextreme-react/data-grid";

import BlockHeader from '../../components/shared/BlockHeader';
import Title from '../../components/shared/Title';
import { _path } from '../../data/headerNavigation';
import { cellRender } from '../../utils/common';
import ScleralNuevo from './ScleralNuevo';
import uri from '../../utils/uri';
import { store } from '../../services/store';
import { openDialogScleral } from '../../store/scleral/scleralDialogReducer';

const Sclerales = () => {

    let dispatch = useDispatch();
    const gridRef = useRef();

    const refreshGrid = () => {
        gridRef.current.instance.refresh();
    }

    const openDialog = id => dispatch(openDialogScleral(id))

    const onToolbarPreparing = e => {

        e.toolbarOptions.items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Exportar a excel',
                icon: 'xlsxfile',
                type: 'success',
                stylingMode: "outlined",
                onClick: () => gridRef.current.instance.exportToExcel(false)
            }
        }, {
            location: 'after',
            widget: 'dxButton',
            options: {
                stylingMode: "outlined",
                type: 'default',
                icon: 'add',
                text: 'Agregar articulo',
                onClick: e => dispatch(openDialog(0))
            }
        });
    }

     const title = 'Lentes Esclerales';

    return (
        <div className="container">
            <Title title={title} />
            <BlockHeader title={title} >
                <Link to={`${_path.CLINICA}/articulos/marco`} className="btn btn-secondary">Marco/Aro</Link>
                <Link to={`${_path.CLINICA}/articulos/lentesOftalmicos`} className="btn btn-secondary" visible={false}>Lentes oftalmicos</Link>
                <Link to={`${_path.CLINICA}/articulos/lentesDeContacto`} className="btn btn-secondary">Lentes de contacto</Link>
                <Link to={`${_path.CLINICA}/articulos/accesorios`} className="btn btn-secondary">Accesorios</Link>
                <Link to={`${_path.CLINICA}/articulos/servicio`} className="btn btn-secondary">Servicios</Link>
            </BlockHeader>

                    <ScleralNuevo updateParent={refreshGrid} typeId={6} />
                    <DataGrid
                        dataSource={store({ uri: {get: uri.scleralItems}, remoteOperations: true })}
                        showBorders={true}
                        selection={{ mode: 'single' }}
                        showRowLines={true}
                        allowColumnResizing={true}
                        allowColumnReordering={true}
                        hoverStateEnabled={true}
                        onToolbarPreparing={onToolbarPreparing}
                        rowAlternationEnabled={true}
                        remoteOperations={{
                            paging: true,
                            filtering: true
                        }}
                        ref={gridRef}
                    >
                        <Editing
                            // mode="popup"
                            allowUpdating={true}
                            allowDeleting={false}
                            allowAdding={false}
                            useIcons={true}

                        >

                        </Editing>
                        <Pager allowedPageSizes={[10, 30, 50]} showPageSizeSelector={true} showInfo={true} />
                        <Paging defaultPageSize={10} />
                        <FilterRow visible={true} />
                        <Column dataField="id" caption="Id" width={60} visible={false} allowEditing={false} />
                        <Column dataField="code" caption="Código" allowEditing={false} width={100} />
                        <Column dataField="brand" caption="Marca" width={250}/>
                        <Column dataField="model" caption="Diseño Lente" />

                        <Column dataField="modelScleral" caption="Modelo" />
                        <Column dataField="typeScleral" caption="Tipo" />
                        <Column dataField="cost" caption="Costo" cellRender={cellRender()} />
                        <Column dataField="price" caption="Precio Vta" cellRender={cellRender()} />
                        <Column dataField="stock" caption="Stock" />

                        <Column type="buttons">
                            <Button name="edit" onClick={(e) => { openDialog(e.row.data.id) }} />
                        </Column>
                    </DataGrid>
                

        </div>
    );
}

export default Sclerales;
